import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import configVars from "../../config";
import { useCookies } from "react-cookie";
import { getWithExpiry, setWithExpiry } from '../../common';
import { useParams } from "react-router-dom";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { updateBoard } from "../../redux/actions/boards";
import { useDispatch } from "react-redux";

const BoardSettings = ( props ) => {

    const [translation] = useTranslation("translations");
    const { board_id } = useParams();
    const userMemberships = useSelector((state) => state.userdata.allUserData.membership_slugs);
    const [boardTitle, setBoardTitle] = useState('');
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [boardGuides, setBoardGuides] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedGuide, setSelectedGuide] = useState(0);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userCharts, setUserCharts] = useState([]);
    const [saving, setSaving] = useState(false);
    const dispatch = useDispatch();
    const [selectedChart, setSelectedChart] = useState(null);
    const [loadingGuides, setLoadingGuides] = useState(false);

    useEffect(() => {

        if ( props?.board?.title ) {
            setBoardTitle( props?.board?.title );
        }

        if ( props?.board?.chart ) {
            setSelectedChart( parseInt( props?.board?.chart , 10 ) );
        }

        if ( props?.board?.associated_users && props?.board?.associated_users.length > 0 ) {

            if (cookies.sustainyou_user_jwt) {
                
                const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
                
                if (jwtDecoded && jwtDecoded.id) {
                    const savedUsers = props?.board?.associated_users.filter( user => parseInt( user.id, 10 ) !== parseInt( jwtDecoded.id, 10 ) ).map(user => {
                        return {id: user.id, name: user.display_name};
                    });
                    setUsers( savedUsers );
                }

            }

            

        }

    }, [props.board, cookies.sustainyou_user_jwt]);

    useEffect(() => {
        if (cookies.sustainyou_user_jwt) {
            const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
            if (jwtDecoded) {
                getUsersList(jwtDecoded);
            }

            getBoardGuides(cookies.sustainyou_user_jwt, userMemberships).then( guides => {

                if ( board_id ) {
                    getSavedBoardGuide(board_id, guides);
                }

            });
          
        }
    }, [cookies, userMemberships, board_id]);

    useEffect(() => {

		if ( ! cookies.sustainyou_user_jwt ) {
            return;
        }

		const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

		if ( !jwtDecoded.id ) return;

		const savedCharts = getWithExpiry( `user_pie_charts_${jwtDecoded.id}` );

		if ( savedCharts ) {
			setUserCharts( savedCharts );
		} else {

			(async () => {

				let userRequestData = new FormData();
				userRequestData.append( 'token', cookies.sustainyou_user_jwt );
	
				setLoading(true);
	
				const fetchUrl = `${configVars.apiUrl}sustainchange/v1/getpiecharts/`;
	
				try{
	
					const response = await fetch(
						fetchUrl,
						{
						method: "POST",
						headers: {
							Authorization: `Basic ${configVars.auth}`,
						},
						body: userRequestData
						}
					);
					
					const updateResponse = await response.json();
			
					if ( updateResponse ) {
	
						if ( updateResponse.success === true ) {
							
							setUserCharts( updateResponse.data.user_charts );
							setWithExpiry( `user_pie_charts_${jwtDecoded.id}`, updateResponse.data.user_charts );
                            window.location.reload();

						}
	
						//console.log( updateResponse );
	
					}
	
				} catch( error ) {
					console.log( error );
					return error;
				}
	
				setLoading(false);
	
			})()

		}


	}, [cookies.sustainyou_user_jwt]);

    const getBoardGuides = async (token, memberships) => {
        const savedBoardGuides = getWithExpiry("sustain_change_board_guides");
    
        if (savedBoardGuides) {
          setBoardGuides(savedBoardGuides);
          return savedBoardGuides;
        } else {

            try {

                setLoadingGuides( true );
                const response = await fetch(
                `${configVars.apiUrl}sustainchange/v1/getmembershipcourses/?token=${token}&memberships=${memberships}`,
                {
                    method: "POST",
                    headers: {
                    Authorization: `Basic ${configVars.auth}`,
                    "Content-Type": "application/json",
                    },
                }
                );
        
                const coursesResponse = await response.json();
        
                //console.log( coursesResponse );
        
                if (coursesResponse && coursesResponse.success === true) {
                setBoardGuides(coursesResponse.data);
                setWithExpiry("sustain_change_board_guides", coursesResponse.data);

                setLoadingGuides( false );

                return coursesResponse.data;
                }
            } catch (error) {}

        }
    };

    const getUsersList = async (jwtDecoded) => {
        try {
          const response = await fetch(
            `${configVars.apiUrl}sustainchange/v1/getcompanyusers/?userid=${jwtDecoded.id}`,
            {
              method: "GET",
              headers: {
                Authorization: `Basic ${configVars.auth}`,
                "Content-Type": "application/json",
              },
            }
          );
          const userResponse = await response.json();
    
          if (userResponse) {
            //console.log(userResponse);
    
            if (userResponse.data.members) {
              setAllUsers(userResponse.data.members);
            }

          }
        } catch (error) {}
    };

    const getSavedBoardGuide = async ( boardID, allGuides ) => {

        let savedGuides = getWithExpiry(`sy_board_${boardID}_guides`);

        if ( ! savedGuides ) {

            const response = await fetch(
                `${configVars.apiUrl}sustainchange/v1/getboardguides/?boardid=${boardID}`,
                {
                  method: "GET",
                  headers: {
                    Authorization: `Basic ${configVars.auth}`,
                  },
                }
              );
      
            const courseResponse = await response.json();

            if (courseResponse && courseResponse.data) {
                const responseData = courseResponse.data.data;
      
                setWithExpiry(`sy_board_${boardID}_guides`, responseData);
      
                savedGuides = responseData;
            }
        }

        if ( savedGuides && savedGuides.course_title && allGuides && allGuides.length > 0 ) {

            const savedGuide = allGuides.filter( item => item.title === savedGuides.course_title );

            if ( savedGuide && savedGuide.length > 0 ) {
                setSelectedGuide( savedGuide[0].id );
            }
            
        }

    }

    const handleSave = async () => {

        if ( !boardTitle || boardTitle.length < 2 ) {
            return;
        }
       
        let selectedUsers = [];
        users.forEach((user) => selectedUsers.push(user.id));
    
        let userSelectedGuide = selectedGuide;
    
        if ( ! userSelectedGuide ) {
          if ( boardGuides.length > 0 ) {
            userSelectedGuide = boardGuides[0]?.id;
          }
        }
    
        try {
            setSaving(true);
            
            
            const boardData = await dispatch(
                updateBoard({
                    id: board_id,
                    title: boardTitle,
                    user_ids: selectedUsers,
                    guide: userSelectedGuide,
                    chart: selectedChart
                })
            );

            if ( boardData ) {

                if ( boardData.data.data.title ) {
                    setBoardTitle( boardData.data.data.title );
                }

                localStorage.removeItem(`sy_board_${board_id}_guides`);
                localStorage.removeItem(`sustainchange_single_board_expiry_${board_id}`);
                localStorage.removeItem('sustainchange_all_boards_expiry');

                window.location.reload();
            }
    
          
          setSaving(false);
        } catch (error) {
          setSaving(false);
        }
      };

    return (
        <div className="p-4 min-vh-100" style={{ maxWidth: "1200px" }}>

            <div className="row mb-4">
                <div className="col-12 col-lg-3">
                    <h3>{translation("board_form.title.label")}</h3>
                </div>
                <div className="col-12 col-lg-9">
                    <input type="text" className="form-control bg-white" value={boardTitle} onChange={ (e) => { setBoardTitle(e.target.value)}} />
                </div>
            </div>

            { userMemberships && userMemberships.length > 0 &&
                <>
                    {boardGuides && boardGuides.length > 0 && (
                        <div className="row mb-4">
                            <div className="col-12 col-lg-3">
                                <h3>Guide</h3>
                            </div>
                            <div className="col-12 col-lg-9">
                                {loadingGuides &&
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }
                                {!loadingGuides &&
                                    <select className="form-select bg-white" value={ boardGuides.length === 1 ? boardGuides[0]?.id : selectedGuide} onChange={(e) => setSelectedGuide(e.target.value)}>
                                        {boardGuides.length > 1 &&
                                            <option>Choose Guide</option>
                                        }
                                        {boardGuides.map((guide, i) => (
                                            <option value={guide.id} key={i}>
                                            {guide.title}
                                            </option>
                                        ))}
                                    </select>
                                }
                                
                            </div>
                        </div>
                    )}

                    { !userMemberships.includes("free") &&
                        <div className="row mb-4">
                            <div className="col-12 col-lg-3">
                                <h3>{translation("board_form.users.label")}</h3>
                            </div>
                            <div className="col-12 col-lg-9 white-input">
                                <Typeahead
                                    id="basic-typeahead-multiple"
                                    labelKey="name"
                                    multiple
                                    onChange={setUsers}
                                    options={allUsers}
                                    placeholder={translation("board_form.users.placeHolder")}
                                    selected={users}
                                />
                            </div>
                        </div>
                    }
                </>
            }

            { userCharts && userCharts.length > 0 &&
                <div className="row">
                    <div className="col-12 col-lg-3">
                        <h3>Pie Chart</h3>
                    </div>
                    <div className="col-12 col-lg-9">

                        {loading &&
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        }
                        { !loading &&
                            <select className="form-select bg-white" value={selectedChart} onChange={(e) => setSelectedChart(e.target.value)}>
                                <option>Välj pie chart</option>

                                { userCharts && userCharts.length > 0 &&
                                    <>
                                        {userCharts.map( (userChart, i) => {
                                            return (
                                                <option value={userChart.id} key={i}>{userChart.title}</option>
                                            );
                                        })}
                                    </>
                                }

                            </select>
                        }

                        <div className="mt-4 d-flex justify-content-end">
                            <button type="button" className="btn btn-primary rounded-pill text-white" onClick={() => handleSave()}>
                                {saving &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }
                                {!saving &&
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                }
                                <span className="ms-2">Spara</span>
                            </button>
                        </div>
                        
                    </div>
                </div>
            }
            

        </div>
    );

}

export default BoardSettings;